{
    "name": "fe-modular-energy-center",
    "version": "1.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --configuration=development",
        "start:aot": "ng serve --configuration=development-aot",
        "build": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=production",
        "build:integration": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=integration",
        "build:staging": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=staging",
        "build:prod": "yarn run build",
        "test": "yarn run lint && yarn run prettier",
        "lint": "eslint .",
        "docs": "npx compodoc -p tsconfig.json -n \"Modular Energy Center - documentation\"",
        "docs:start": "compodoc --serve --port 9000",
        "serve": "node node_modules/http-server/bin/http-server -c-1 -p 4200 dist",
        "serve:dev": "ng build --configuration=integration && yarn run serve",
        "prettier": "prettier --check src/**/*.ts"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^20.3.25",
        "@angular/cdk": "^20.2.14",
        "@angular/common": "^20.3.25",
        "@angular/compiler": "^20.3.25",
        "@angular/core": "^20.3.25",
        "@angular/flex-layout": "^15.0.0-beta.42",
        "@angular/forms": "^20.3.25",
        "@angular/material": "^20.2.14",
        "@angular/material-moment-adapter": "^20.2.14",
        "@angular/platform-browser": "^20.3.25",
        "@angular/platform-browser-dynamic": "^20.3.25",
        "@angular/pwa": "0.12.2",
        "@angular/router": "^20.3.25",
        "@angular/service-worker": "^20.3.25",
        "@auth0/angular-jwt": "^4.2.0",
        "@ngx-translate/core": "^14.0.0",
        "@ngx-translate/http-loader": "^4.0.0",
        "@types/ineum": "^216.0.0",
        "@types/uuid": "^8.3.0",
        "@vi-succ/design-system-web": "^1.3.0",
        "@vi/global-header": "15.3.3",
        "@vi/quest": "15.7.2",
        "angular2-recaptcha": "^1.1.0",
        "core-js": "^2.5.4",
        "deepmerge-ts": "^7.0.3",
        "lodash": "^4.17.21",
        "moment": "^2.29.1",
        "ngx-translate-multi-http-loader": "17.0.0",
        "ngx-uploader": "16.0.0",
        "rxjs": "^7.8.1",
        "tslib": "^2.0.0",
        "underscore": "^1.9.0",
        "uuid": "^8.3.2",
        "zone.js": "~0.15.1",
        "@everest/codestyle": "2.0.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.29",
        "@angular-eslint/eslint-plugin": "^18.4.3",
        "@angular-eslint/schematics": "18.4.3",
        "@angular-eslint/template-parser": "18.4.3",
        "@angular/cli": "^20.3.29",
        "@angular/compiler-cli": "20.3.25",
        "@angular/language-service": "^20.3.25",
        "@compodoc/compodoc": "^1.1.9",
        "@types/lodash": "^4.17.16",
        "@types/node": "~12.12.6",
        "@types/puppeteer": "^3.0.1",
        "@typescript-eslint/eslint-plugin": "7.13.1",
        "@typescript-eslint/parser": "7.13.1",
        "codelyzer": "^6.0.0",
        "@everest/eslint-config": "1.3.2",
        "eslint": "8.57.0",
        "fs-finder": "^1.8.1",
        "http-server": "^0.11.1",
        "istanbul-reports": "^2.0.0",
        "jasmine-core": "~3.6.0",
        "jasmine-spec-reporter": "~5.0.0",
        "ngx-translate-testing": "6.1.0",
        "prettier": "^2.3.2",
        "puppeteer": "^4.0.1",
        "rimraf": "^2.6.2",
        "run-sequence": "2.2.1",
        "ts-node": "~7.0.0",
        "typescript": "5.8.3"
    },
    "packageManager": "yarn@1.22.22"
}
